
import { defineComponent } from "vue";
import { TooltipLocationType } from "./tooltip-location-type";

export default defineComponent({
  inheritAttrs: false,
  props: {
    location: {
      type: String as () => TooltipLocationType,
      required: false,
      default: "start",
    },
    text: {
      type: String,
      required: false,
    },
  },
});
